export default "__VITE_ASSET__DdSlpSAG__"